import * as React from "react";
function StatusAlertIcon(props) {
    return React.createElement("svg", { fill: "none", viewBox: "0 0 17 16", height: "1em", width: "1em", ...props },
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M.751 16a.75.75 0 0 1-.67-1.085L7.33.415a.75.75 0 0 1 1.34 0l7.25 14.5A.75.75 0 0 1 15.25 16zm6.5-10h1.5v5h-1.5zm.75 7.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5", clipRule: "evenodd" }));
}
export default StatusAlertIcon;
//# sourceMappingURL=StatusAlert.js.map